import { createContext, useContext } from "react";

export interface UserSearchCriteria {
    emailSearchText: string;
    firstNameSearchText: string;
    lastNameSearchText: string;
    idSearchValue?: number;
    roleType?: number;
    currentPage: number;
}

export interface UserSearchContextParams {
    initialCriteria: UserSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<UserSearchCriteria>>;
}

const defaultUserSearchCriteria: UserSearchCriteria = {
    emailSearchText: "",
    firstNameSearchText: "",
    lastNameSearchText: "",
    idSearchValue: undefined,
    roleType: undefined,
    currentPage: 1,
};

const UserSearchContext = createContext<UserSearchContextParams>({
    initialCriteria: defaultUserSearchCriteria,
    setCriteria: () => {},
});

const useUserSearch = () => {
    return useContext(UserSearchContext);
};

export { UserSearchContext, useUserSearch, defaultUserSearchCriteria };
